export function generateYearOptions() {
    const start = new Date().getFullYear();
    const stop = 1900;
    const step = -1;
    return Array.from({length: (stop - start) / step + 1}, (_, i) => {
        return {name: (start + i * step).toString()};
    });
}
